

import {isEmpty} from 'lodash-es';
import {SocialProfile} from "@/models/Social/social-profile";
import {BlockItemAction} from "@/models/Blocks/Itens/Types/block-content-types";
import {BlockContent} from "@/models/Blocks/Itens/block-content";
import {TemplateItemType} from "@/models/Blocks/Itens/Types/template-item-type";
import {cloneDeep} from "lodash-es/lodash";

export default {
    name: 'DesktopSocialGallery',
    components: {
        Single: () => import("@/components/Blocks/Block/Single.vue"),
        VideoModal: () => import('@/components/ProductPage/Desktop-BlackRabbit/VideoModal.vue'),
        ZoomGallery: () => import("@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/ZoomGallery.vue"),
    },
    props: {
        profile:{
            type: SocialProfile | Object,
            default: () => new SocialProfile(),
            required: true
        },
        kStrings:{
            type: Object,
            default: () => {},
            required: true
        }
    },
    data() {
        return {
            selectedPosition: 1,
            showZoomGallery: false,
            showVideoModal: false
        };
    },
//    watch: {},
    computed: {
        images() {
            if (isEmpty(this.profile.galleryImages)) {
                return null;
            }

            let imgAssets = this.profile.galleryImages.images.sort((a, b) => a.position - b.position);
            return imgAssets.map(a => a.imageUrl);

            //return this.profile.galleryImages.images;
        },
        thumbs() {
            if (isEmpty(this.profile.galleryImages)) {
                return null;
            }

            let imgAssets = this.profile.galleryImages.thumbs.sort((a, b) => a.position - b.position);
            return imgAssets.map(a => a.imageUrl);

            //return this.profile.galleryImages.thumbs;
        },
        zoomImages() {
            if (isEmpty(this.profile.galleryImages)) {
                return null;
            }

            let imgAssets = this.profile.galleryImages.zoomImages.sort((a, b) => a.position - b.position);
            return imgAssets.map(a => a.imageUrl);

            //return this.profile.galleryImages.zoomImages;
        },
        remainingImages() {
            if(isEmpty(this.images)) {
                return 0;
            }

            let remaining = this.images.length - 5;
            // wew 3 ifs
            if(this.profileVideoBlock) {
                remaining += 2;
            }

            if(this.experienceBlock) {
                remaining += 1;
            }

            if(this.availabilityBlock) {
                remaining += 1;
            }

            if(this.credentialsBlock) {
                remaining += 1;
            }

            return remaining > 0 ? remaining : 0;
        },
        zoomGalleryData() {
            if (!this.images) {
                return null;
            }

            return {
                images: this.images,
                zoomImages: this.zoomImages,
                thumbs: this.thumbs,
                defaultPosition: this.selectedPosition
            }
        },
        followers():string|number{
            return this.profile.followersFormatted ?? this.profile.followers;
        },
        profileVideoBlock() {
            const video = this.profile.galleryImages.video;
            if(video) {
                const action = new BlockItemAction('video', null, null, 'prz-expand');
                let struct = new BlockContent(null, action);
                struct.cssClass = 'prz-blk-content-no-gradient';
                struct.addImage(video.poster, null, true);
                struct.templateType = TemplateItemType.horizontal;
                struct.backgroundColor = 'transparent';
                struct.setVideo(video.source, video.poster);

                return struct;
            }
            return null;
        },
        videoObject() {
            return {
                poster: this.profile.galleryImages.video.poster,
                url: this.profile.galleryImages.video.source
            }
        },
        hasPublications() {
            return !this.profileVideoBlock;
        },
        hasCoupon() {
            return !this.profileVideoBlock && this.profile.promo;
        },
        experienceBlock () {
            if (isEmpty(this.profile.galleryImages)) {
                return null;
            }

            if(this.profileVideoBlock) {
                return null;
            }

            return this.profile.galleryImages.experienceBlock;
        },
        availabilityBlock () {
            if (isEmpty(this.profile.galleryImages)) {
                return null;
            }

            if(this.profileVideoBlock) {
                return null;
            }

            return this.profile.galleryImages.availabilityBlock;
        },
        credentialsBlock() {
            if (isEmpty(this.profile.galleryImages)) {
                return null;
            }

            return this.profile.galleryImages.credentialsBlock;
        },
        mainBlock() { // main square pos 1
            if(isEmpty(this.images)) {
                return null;
            }
            
            return {
                src: this.images[0] ? this.images[0] : this.profile.image,
                alt: this.profile.name + '-img-main',
                type: 'image',
                cssClass: 'square-item',
                style: {
                    background: this.profile.blocksColor
                }
            };
        },
        gridBlocks() { // grid on the side of main square
            if(isEmpty(this.images)) {
                return null;
            }

            // base photo block
            let photoBlock = {
                src: this.images[1],
                alt: this.profile.name + '-img-1',
                type: 'image',
                cssClass: 'grid-item grid-img',
                zoomPos: 2,
                style: {
                    background: this.profile.blocksColor,
                    order: 1
                }
            }
            let blocks = [];
            // horizontal video -> pos 1 & 2 (top left & top right)
            if(this.profileVideoBlock) {
                let videoBlock = {
                    blockObj: this.profileVideoBlock,
                    type: 'video',
                    cssClass: 'grid-item video-block horizontal',
                    style: {
                        order: 1
                    }
                }
                blocks.push(videoBlock);
            } else {
                // NO VIDEO (pos 1 & 2)
                // photo number 1 -> pos 1 (top left)
                blocks.push(photoBlock);
                // pos 2 experience || publication stats (top right)
                if(this.experienceBlock) {
                    let expBlock = {
                        blockObj: this.experienceBlock,
                        type: 'experience',
                        cssClass: 'grid-item custom-image',
                        style: {
                            background: this.experienceBlock.color,
                            color: this.experienceBlock.textColor ? this.experienceBlock.textColor : this.profile.blocksColor,
                            order: 2
                        }
                    }
                    blocks.push(expBlock);
                } else if(this.availabilityBlock) {
                    let availBlock = {
                        blockObj: this.availabilityBlock,
                        type: 'availability',
                        cssClass: this.availabilityBlock.items.length == 1 ? 'grid-item custom-image single' : 'grid-item custom-image',
                        style: {
                            background: this.availabilityBlock.backgroundColor,
                            color: this.availabilityBlock.textColor ? this.availabilityBlock.textColor : this.profile.blocksColor,
                            order: 2
                        }
                    }
                    blocks.push(availBlock);
                } else if(this.hasPublications) {
                    let pubBlock = {
                        type: 'stats',
                        cssClass: 'grid-item stats-block',
                        style: {
                            background: this.profile.blocksColor,
                            order: 2
                        }
                    }
                    blocks.push(pubBlock);
                }
            }
            // pos 3 & 4 (bottom left & bottom right)
            // pos 3 (credentials -> coupon -> image 2
            if(this.credentialsBlock) {
                let credBlock = {
                    blockObj: this.credentialsBlock,
                    type: 'credentials',
                    cssClass: 'grid-item custom-image',
                    style: {
                        background: this.credentialsBlock.backgroundColor,
                        color: this.credentialsBlock.textColor ? this.credentialsBlock.textColor : this.profile.blocksColor,
                        order: 3,
                    }
                }
                blocks.push(credBlock);
            } else if(this.hasCoupon) {
                let couponBlock = {
                    blockObj: this.profile.promo,
                    type: 'promo',
                    cssClass: 'grid-item coupon-block',
                    style: {
                        background: this.profile.blocksColor,
                        order: 3,
                    }
                }
                blocks.push(couponBlock);
            } else { // no credentials || no coupon (very rare)
                let photoTwoBlock = cloneDeep(photoBlock);
                photoTwoBlock.src = this.images[2];
                photoTwoBlock.alt = this.profile.name + '-img-2';
                photoTwoBlock.zoomPos = 3;
                photoTwoBlock.style.order = 3;
                blocks.push(photoBlock);
            }
            // pos 4 (photo 1 (with video) -> photo 2 (no video) (3 if no coupon || no credential block))
            if(this.profileVideoBlock) {
                let photoOne = cloneDeep(photoBlock);
                photoOne.style.order = 4;
                photoOne.showRemaining= true;
                blocks.push(photoOne);
            } else if(this.hasCoupon || this.credentialsBlock) {
                let photoTwoBlock = cloneDeep(photoBlock);
                photoTwoBlock.src = this.images[2];
                photoTwoBlock.alt = this.profile.name + '-img-2';
                photoTwoBlock.zoomPos = 3;
                photoTwoBlock.style.order = 4;
                photoTwoBlock.showRemaining= true;
                blocks.push(photoTwoBlock);
            } else {
                let photoThreeBlock = cloneDeep(photoBlock);
                photoThreeBlock.src = this.images[3];
                photoThreeBlock.alt = this.profile.name + '-img-3';
                photoThreeBlock.zoomPos = 4;
                photoThreeBlock.style.order = 4;
                photoThreeBlock.showRemaining= true;
                blocks.push(photoThreeBlock);
            }

            return blocks;
        }
    },
    methods: {
        openZoomGallery(position = 1) {
            this.selectedPosition = position;
            this.showZoomGallery = true;
        },
        clickGalleryBlock(block){
            if(block.type == 'image') {
                this.openZoomGallery(block.zoomPos??1);
            }

            if(block.type == 'video') {
                this.showVideoModal = true
            }
        },

    },
     mounted() {
    //     this.$nextTick(() => {});
    },
};
